import { TopMenu } from "../../top-menu/TopMenu";
import { Footer } from "../../footer/Footer";
import TeamWork from '../../../assets/Hands_Of_Contemporary_Engineer_With..._original_438132.jpg';

export const Services = () => (
    <div className="min-h-screen flex flex-col">
        <TopMenu />
        <main className="flex-1 py-10 px-5 grid grid-cols-1 md:grid-cols-3 gap-10">
            <div className="text-justify">
                <h1 className="bg-navy text-white pl-2.5 mt-0">SERVICES</h1>
                <p>For complex structural and miscellaneous steel projects, we deliver high-quality detailing
                    services that simplify your process. Utilizing SDS2 3D modeling, we produce comprehensive shop
                    drawings and models that enhance coordination, reduce costs, and streamline your fabrication and
                    erection phases. Our design-assist and delegated design capabilities provide you with the
                    expertise needed to optimize your commercial, industrial, and public works projects from the
                    start.</p>
                <h2 className="text-navy">Structural and Miscellaneous Steel Detailing</h2>
                <ul>
                    <li>Structural and Miscellaneous Steel Detailing - Drawing Logs</li>
                    <li>Shop Drawings</li>
                    <li>Erection and Placement Plans and Details</li>
                    <li>Parts Details</li>
                    <li>Field Bolt Lists and many bolt reports as desired</li>
                    <li>Cnc, nc1, dstv, and dxf files for your automated fabricating equipment.</li>
                    <li>Tekla PowerFab and kss files for your production management software.</li>
                </ul>
                <h2 className="text-navy">Other services</h2>
                <ul>
                    <li>BIM management services.</li>
                    <li>Project Management.</li>
                    <li>Collaboration with your customer and design teams.</li>
                </ul>
            </div>
            <div className="md:col-span-2 text-center">
                <img src={TeamWork} alt="Services" className="w-4/5 mx-auto block" />
            </div>
        </main>
        <Footer />
    </div>
);
